import { setCookie } from 'nookies';
import { LoggedUser } from '../data/dto/logged-user.dto';
import LocalStorageService from './LocalStorageService';


const COOKIE_USER_TOKEN = `AMARELINHO_USER_TOKEN`;
const COOKIE_ASP_SESSION_ID = `ASP.NET_SessionId`;
const COOKIE_AUTH = 'AMARELINHO.PORTAL.ASPXFORMSAUTH';
const cookieOptions = {
  path: `/`,
  domain: process.env.REACT_APP_COOKIES_DOMAIN,
};

export class UserService {
  static readonly key = '_123_USER';
  private static user: LoggedUser | null = null;
  static getLoggedUser(): LoggedUser {
    if (!this.user) {
      this.user = LocalStorageService.getItem(this.key);
      this.setCookies();
    }
    return this.user!;
  }

  static setLoggedUser(loggedUser: LoggedUser) {
    this.user = loggedUser;
    LocalStorageService.setItem(this.key, loggedUser);
    this.setCookies();
  }

  private static setCookies() {
    setCookie(null, COOKIE_USER_TOKEN, this.user!.token, cookieOptions);
    setCookie(null, COOKIE_ASP_SESSION_ID, this.user!.cookie.sessionCookie, cookieOptions);
    setCookie(null, COOKIE_AUTH, this.user!.cookie.authCookie, cookieOptions);
  }
}